// import { BootstrapVue, IconsPlugin, VBScrollspyPlugin } from 'bootstrap-vue';
import {
    BootstrapVue,
    CalendarPlugin,
    FormDatepickerPlugin,
    FormFilePlugin,
    FormTimepickerPlugin,
    PaginationPlugin,
    TimePlugin,
} from 'bootstrap-vue';
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueLodash from 'vue-lodash';
import lodash from 'lodash';
import VueMomentJS from 'vue-momentjs';
import moment from 'moment';
import App from './App.vue';
import router from './router';
import plugins from './plugin/index';
import store from './store';
import GlobalComponents from './globalComponents';
import common from './assets/js/common';
import CKEditor from '@ckeditor/ckeditor5-vue';
import { initializeApp } from 'firebase/app';
import VueSSE from 'vue-sse';
import VModal from 'vue-js-modal';
import VueDragDrop from 'vue-drag-drop';
import html2pdf from '@/assets/js/htmltopdf/html2pdf.bundle.js';
import PortalVue from 'portal-vue';

import Element from 'element-ui';
import './assets/scss/element-variables.scss';
import locale from 'element-ui/lib/locale/lang/ko';

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

/* scss */
import './assets/scss/globals.scss';
import './assets/scss/main.scss';

/* filter */
import './assets/js/filter.js';

import './registerServiceWorker.js';

// cookies;
import VueCookies from 'vue-cookies';
import './plugin/apexcharts';
import './index.scss';

Vue.prototype.$uiDevMode = false;

const firebaseConfig = {
    apiKey: 'AIzaSyDxeGGyIWghndMX23E-tGkfcXUlBWCE2wo',
    authDomain: 'fittodaycare-89b9a.firebaseapp.com',
    projectId: 'fittodaycare-89b9a',
    storageBucket: 'fittodaycare-89b9a.appspot.com',
    messagingSenderId: '677806961533',
    appId: '1:677806961533:web:c5cfe6886912bb96dd1214',
    measurementId: 'G-BNNBPLNL0T',
};
initializeApp(firebaseConfig);

Vue.use(BootstrapVue);
Vue.use(PaginationPlugin);
Vue.use(CalendarPlugin);
Vue.use(FormDatepickerPlugin);
Vue.use(FormFilePlugin);
Vue.use(FormTimepickerPlugin);
Vue.use(TimePlugin);
// Vue.use(IconsPlugin);
// Vue.use(VBScrollspyPlugin);
Vue.use(VueLodash, { name: 'custom', lodash });
Vue.use(VueAxios, axios);
Vue.use(plugins);
Vue.use(common);
Vue.use(VueMomentJS, moment);
Vue.use(CKEditor);
Vue.use(PortalVue);

Vue.use(Element, { locale });

Vue.config.productionTip = false;

Vue.use(VueCookies);

Vue.use(VueDragDrop);

Vue.$cookies.keys().forEach((cookie) => {
    // 프로젝트 로딩시 쿠키삭제.
    Vue.$cookies.remove(cookie);
    console.log(cookie);
});

Vue.use(VueSSE);
Vue.use(VModal);

// const api = axios.create({
//   baseURL: 'http://127.0.0.1:3000',
//   timeout: 3000,
//   // headers: { 'X-Custom-Header': 'foobar' },
// });
//
// api.interceptors.response.use(response => response, (error) => {
//     console.log("===> axios interceptors error :", error);
//   throw error;
// });

/* 글로벌 컴포넌트 */
Object.entries(GlobalComponents).forEach(([name, component]) => {
    Vue.component(name, component);
});

Vue.directive('click-outside', {
    bind(el, binding, vnode) {
        // eslint-disable-next-line func-names
        el.clickOutsideEvent = function (event) {
            if (!(el === event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    },
    unbind(el) {
        document.body.removeEventListener('click', el.clickOutsideEvent);
    },
});

export const EventBus = new Vue();

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
